import React from 'react';
const community = [{
  name: 'Silvina G. - Córdoba',
  quote: '"Nunca pensé que con la pre-venta podría arrancar sin plata. Me financié con mis primeros 5 clientes y hoy vivo de esto."',
  image: 'https://cdn.magicpatterns.com/uploads/2ZXD64QsxqNkPgvhHJQJWh/Captura_de_pantalla_2026-04-30_a_las_9.24.04_p._m..png'
}, {
  name: 'Romina A. - Lanús',
  quote: '"Lo que más valoro es el tiempo. Antes trabajaba 9 horas afuera, ahora manejo mis horarios y estoy presente en la crianza de mis nenes."',
  image: 'https://cdn.magicpatterns.com/uploads/cTEh2GU5Sqj6MiGdsTSsH3/Captura_de_pantalla_2026-04-30_a_las_9.24.11_p._m..png'
}, {
  name: 'Beatriz L. - Mendoza',
  quote: '"La planilla de costos automática es una maravilla. Antes cobraba a ojo y perdía plata. Ahora mi negocio es sólido y rentable."',
  image: 'https://cdn.magicpatterns.com/uploads/cXy8bY9ULhh4scqZQeZxha/Captura_de_pantalla_2026-04-30_a_las_9.24.24_p._m..png'
}, {
  name: 'Carla D. - Santa Fe',
  quote: '"Los guiones de venta son magia pura. No sabía cómo cobrar sin sonar mal, y esto me dio seguridad profesional. La gente paga contenta."',
  image: 'https://cdn.magicpatterns.com/uploads/bRaeF4mQT6gaA9YJo6s5ke/Captura_de_pantalla_2026-04-30_a_las_9.24.33_p._m..png'
}, {
  name: 'Estefanía R. - CABA',
  quote: '"Organización total. El sistema de Batch Cooking me permite tener vida social los fines de semana y vender toda la semana."',
  image: 'https://cdn.magicpatterns.com/uploads/bBHMD718vJsL8vbhD78BLK/Captura_de_pantalla_2026-04-30_a_las_9.24.40_p._m..png'
}, {
  name: 'Gabriela P. - Neuquén',
  quote: '"Me especialicé en viandas saludables como sugiere el curso y no paro de vender. Hay mucha demanda y poca gente profesional."',
  image: 'https://cdn.magicpatterns.com/uploads/tVRhkJbfeWV7tcVQn76Kpg/Captura_de_pantalla_2026-04-30_a_las_9.24.46_p._m..png'
}, {
  name: 'Patricia S. - Mar del Plata',
  quote: '"Es la mejor inversión que hice. Recuperé el valor del curso con mi primer pedido grande de una oficina. Recomendadísimo."',
  image: 'https://cdn.magicpatterns.com/uploads/qaQZBo1wXWLQcmurFehsiY/Captura_de_pantalla_2026-04-30_a_las_9.24.54_p._m..png'
}, {
  name: 'Luciana V. - Tucumán',
  quote: '"El Kit Pro me hizo ver como una empresa seria desde el día 1. Las etiquetas y el menú digital marcan la diferencia."',
  image: 'https://cdn.magicpatterns.com/uploads/dbbeJ5sS8XRAqEVStE4y7d/Captura_de_pantalla_2026-04-30_a_las_9.25.00_p._m..png'
}];
export function CommunitySection() {
  return <section className="w-full bg-[#f9f8f4] px-4 md:px-8 py-16" data-id="element-49">
      <div className="max-w-[900px] mx-auto" data-id="element-50">
        {/* Title */}
        <div className="text-center mb-10" data-id="element-51">
          <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl lg:text-[34px] font-bold text-[#1a1a1a] leading-tight uppercase tracking-wide" data-id="element-52">
            Comunidad de Emprendedoras Exitosas ⭐⭐⭐⭐⭐
          </h2>
          <div className="w-16 h-1 bg-[#4caf50] mx-auto mt-4" data-id="element-53"></div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-54">
          {community.map((item, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_16px_rgba(0,0,0,0.08)]" data-id="element-55">
              {/* Image */}
              <div className="w-full aspect-[4/3] bg-[#e8e8e8] overflow-hidden" data-id="element-56">
                {item.image ? <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-57" /> : <div className="w-full h-full flex items-center justify-center text-gray-400 font-['Montserrat',_sans-serif] text-sm" data-id="element-58">
                    [Imagen pendiente]
                  </div>}
              </div>

              {/* Content */}
              <div className="p-5" data-id="element-59">
                <p className="font-['Montserrat',_sans-serif] text-[#1a1a1a] font-bold text-base mb-1" data-id="element-60">
                  {item.name}
                </p>
                <div className="flex gap-0.5 text-sm mb-3" data-id="element-61">
                  <span data-id="element-62">⭐</span>
                  <span data-id="element-63">⭐</span>
                  <span data-id="element-64">⭐</span>
                  <span data-id="element-65">⭐</span>
                  <span data-id="element-66">⭐</span>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-[#555] text-sm md:text-base leading-relaxed" data-id="element-67">
                  {item.quote}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}